// Used by account / user-app
export class Constants {
    public static QUERY_PARAM_REDIRECT_FLOW = "redirectFlow";
    public static QUERY_PARAM_REDIRECT_URL = "redirectUrl";
}